<div class="pt-3" *ngIf="privateEventNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="mt-3 alert alert-danger" *ngIf="missingPermission">
  You need the "Can manage events" permission in order to manage this private event.
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!privateEventNotFound && (serverError === null) && !missingPermission">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="!privateEvent">LOADING PRIVATE EVENT...</span>
        <span *ngIf="privateEvent">EDIT PRIVATE EVENT: {{ privateEvent.event_type_name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-3 border-rounded-10">

    <app-private-event-setup-nav [loadingEvent]="loadingPrivateEvent"
                                 [privateEvent]="privateEvent"></app-private-event-setup-nav>

    <div class="m-4" *ngIf="serverError">
      <h3 class="text-danger">Server Error: {{ serverError }}</h3>
    </div>

    <div class="m-4" *ngIf="!serverError && isLoading()">
      <h3 class="text-muted">Loading...</h3>
    </div>

    <div class="m-4" *ngIf="!serverError && !isLoading()">

      <p>
        Status:
        <b *ngIf="parseFloat(booking.amount_due) <= 0">Fully Paid</b>
        <b *ngIf="parseFloat(booking.amount_due) > 0">
          {{ parseFloat(booking.amount_paid) > 0 ? 'Partially Paid' : 'Unpaid' }}
        </b>
      </p>

      <div class="mb-3">
        <ng-container *ngIf="privateEvent.event_parts.length === 1">
          {{ dateStringFromISO8601(privateEvent.event_parts[0].start_datetime_isoformat) }},
          {{ timeStringFromISO8601(privateEvent.event_parts[0].start_datetime_isoformat) }} -
          {{ timeStringFromISO8601(privateEvent.event_parts[0].end_datetime_isoformat) }}
          <br>
        </ng-container>
        <ng-container *ngIf="privateEvent.event_parts.length > 1">
          Dates:
          <ul class="mb-1">
            <li *ngFor="let eventPart of privateEvent.event_parts">
              {{ dateStringFromISO8601(eventPart.start_datetime_isoformat) }},
              {{ timeStringFromISO8601(eventPart.start_datetime_isoformat) }} -
              {{ timeStringFromISO8601(eventPart.end_datetime_isoformat) }}
            </li>
          </ul>
        </ng-container>
        {{ booking.reservations.length }} participants
      </div>

      <p *ngIf="parseFloat(booking.discount_amount) > 0">
        Total fees at full price: {{ orgConfig.getCurrencySymbol() }}{{ booking.total_fee_without_discount }}
        <br>
        Discount amount: {{ orgConfig.getCurrencySymbol() }}{{ booking.discount_amount }}
        <ng-container *ngIf="!orgConfig.getOrganizationConfig().price_includes_tax">
          (applied pre-tax)
        </ng-container>
      </p>

      <p>
        Total fees: {{ orgConfig.getCurrencySymbol() }}{{ booking.total_fee }}
        <br>
        Amount paid to date: {{ orgConfig.getCurrencySymbol() }}{{ booking.amount_paid }}
        <br>
        Amount refunded to date: {{ orgConfig.getCurrencySymbol() }}{{ booking.amount_refunded }}
        <br>
        <b>Outstanding balance: {{ orgConfig.getCurrencySymbol() }}{{ booking.amount_due }}</b>
      </p>

      <div class="form-group"
           *ngIf="parseFloat(booking.amount_due) > 0 && orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().allow_offline_payments">
        <button class="btn btn-sm btn-outline-primary" type="button"
                [disabled]="loadingPayment || booking.pending_requested_payment !== null"
                [class.disabled]="loadingPayment || booking.pending_requested_payment !== null"
                [ngbTooltip]="booking.pending_requested_payment ? 'Cancel the existing pending requested payment first.' : null"
                (click)="handleMarkPaidOffline()">
          Mark event as paid offline
        </button>
        <small class="form-text text-muted">
          Select this option if payment will be handled offline via check or invoice. Revenue will then not be included in any accounting reports or integrations, but will display in internal revenue reporting. The payment method will display as "Offline Payment" in Capitan.
        </small>
      </div>

      <ng-container *ngIf="booking.payments.length > 0 || booking.pending_requested_payment">
        <label class="mb-0">Payment history</label>
        <ul>
          <li *ngFor="let payment of booking.payments">
            {{ orgConfig.getCurrencySymbol() }}{{ payment.amount }}
            paid on {{ dateStringFromISO8601(payment.date) }}
            <ng-container *ngIf="parseFloat(payment.amount_refunded) > 0">
              <ng-container *ngIf="parseFloat(payment.amount_refunded) >= parseFloat(payment.amount)">
                (<span class="text-danger">fully refunded</span>)
              </ng-container>
              <ng-container *ngIf="parseFloat(payment.amount_refunded) < parseFloat(payment.amount)">
                (<span class="text-danger">{{ orgConfig.getCurrencySymbol() }}{{ payment.amount_refunded }} refunded</span>)
              </ng-container>
            </ng-container>
          </li>
          <li *ngIf="booking.pending_requested_payment">
            <b>Pending Requested Payment</b>:
            {{ orgConfig.getCurrencySymbol() }}{{ booking.pending_requested_payment.amount }}
            requested on {{ dateStringFromISO8601(booking.pending_requested_payment.created_at) }}
            <div class="d-flex align-items-center" style="gap: 12px;">
              <button class="btn btn-sm btn-outline-secondary"
                      [disabled]="loadingPayment"
                      [class.disabled]="loadingPayment"
                      (click)="handleCopyRequestedPaymentLink()">
                Copy Link
              </button>
              <button class="btn btn-sm btn-outline-secondary"
                      [disabled]="loadingPayment"
                      [class.disabled]="loadingPayment"
                      (click)="handleResendRequestedPaymentEmail()">
                {{ booking.pending_requested_payment.has_been_emailed ? 'Resend Email' : 'Send Email' }}
              </button>
              <button class="btn btn-sm btn-outline-danger"
                      [disabled]="loadingPayment"
                      [class.disabled]="loadingPayment"
                      (click)="handleCancelRequestedPayment()">
                Cancel
              </button>
              <small class="text-success" *ngIf="requestedPaymentLinkCopied">
                Payment link copied.
              </small>
            </div>
          </li>
        </ul>
      </ng-container>

      <div class="float-right d-flex" style="gap: 12px;" *ngIf="booking.payment_processor_type !== null">
        <ng-container *ngIf="parseFloat(booking.amount_due) > 0">
          <button class="btn btn-outline-primary"
                  [disabled]="loadingPayment || booking.pending_requested_payment !== null"
                  [class.disabled]="loadingPayment || booking.pending_requested_payment !== null"
                  [ngbTooltip]="booking.pending_requested_payment ? 'Cancel the existing pending requested payment first.' : null"
                  (click)="handleRequestPayment()">
            Request Payment
          </button>
          <button class="btn btn-primary"
                  [disabled]="loadingPayment || booking.pending_requested_payment !== null"
                  [class.disabled]="loadingPayment || booking.pending_requested_payment !== null"
                  [ngbTooltip]="booking.pending_requested_payment ? 'Cancel the existing pending requested payment first.' : null"
                  (click)="handlePayNow()">
            {{ loadingPayment ? 'Loading...' : 'Pay Now' }}
          </button>
        </ng-container>
        <button class="btn btn-primary"
                *ngIf="parseFloat(booking.amount_due) < 0"
                [disabled]="loadingPayment"
                [class.disabled]="loadingPayment"
                (click)="handleRefundExcess()">
          {{ loadingPayment ? 'Loading...' : 'Refund Excess' }}
        </button>
      </div>

      <div class="float-right" *ngIf="booking.payment_processor_type === null">
        <button class="btn btn-secondary disabled" disabled>
          No Payment Processor Configured
        </button>
      </div>

      <a class="btn btn-secondary mt-3"
         [routerLink]="getBackLink()">
        Back to Event Details
      </a>

    </div>

  </div>

</div>
